// extracted by mini-css-extract-plugin
module.exports = {"GiftsNotification":"index-module--GiftsNotification--RXuEr","Bounce":"index-module--Bounce--2fd6L","Bouncing":"index-module--Bouncing--2rY73"};